import { useState, useEffect, Fragment } from 'react';
import { DataGrid, Column, Lookup, Editing, RequiredRule } from 'devextreme-react/data-grid';
import { CreateAuthorizedDataSource } from '~/helpers/data';
import { appConst } from '~/app-const';

const URL = `${window.env.apiEndpoint}/api/v1/CommitteeMemberships`;

export const CommitteeMembershipRoleDetails = (props) => {
  const [roleLookups, setRoleLookups] = useState();

  const getRoles = (key) => {

    let ds = CreateAuthorizedDataSource(
      {
        loadUrl: `${URL}/GetRolesForCommitteeMembership`,
        updateUrl: `${URL}/PutCommitteeMembershipRole`,
        deleteUrl: `${URL}/DeleteCommitteeMembershipRole`,
        insertUrl: `${URL}/PostCommitteeMembershipRole`,
      },
      {
        load: { 'committeeMembershipId': key, 'refDate': props.refDate },
        insert: { 'committeeMembershipId': key },
      }
      , 'Id');
    return ds;
  };

  useEffect(() => {
    async function fetchData() {
      const roleLookupsStore = CreateAuthorizedDataSource(
        { loadUrl: `${window.env.apiEndpoint}/api/v1/CommitteeMemberships/GetRoleLookupsForCommittee` },
        { load: { committeeId: props.committeeId }, }, 'Value');
      setRoleLookups(await roleLookupsStore.load());
    }
    fetchData();
  }, [props.committeeId]);
  const dataSource = getRoles(props.committeeMembershipId);
  return (
    <Fragment>
      <DataGrid
        id="committeeMembershipRoleDetailsGrid"
        dataSource={dataSource}
        showBorders={true}
        columnAutoWidth={true}
        onRowUpdated={() => {
          props.refreshMasterGrid();
        }}
        onRowInserted={() => {
          props.refreshMasterGrid()
        }}
        onRowRemoved={() => {
          props.refreshMasterGrid()
        }}
        onInitNewRow={(e) => {
          e.data.StartDate = props.startDate;
          e.data.EndDate = props.EndDate;
        }}
        onEditorPreparing={(e) => {
          if (e.dataField === "CommitteeRoleId" && !e.row.isNewRow) {
            e.editorOptions.disabled = true;
          }
        }}
        onRowPrepared={(e) => {
          if (e.rowType === "data") {
            if (new Date(e.data.EndDate) < new Date()) {
              e.rowElement.style.backgroundColor = "lightGray";
            }
          }
        }}
      >
        <Editing
          mode="row"
          allowAdding
          allowDeleting
          allowUpdating
        />
        <Column
          dataField='CommitteeRoleId'
          caption='Role'
          allowEditing={true}
        >
          <RequiredRule/>
        <Lookup
          dataSource={roleLookups}
          valueExpr="Value" 
          displayExpr="Text" />
        </Column>
        <Column
          dataField="StartDate"
          dataType="date"
          format={appConst.dateDisplayFormat}
        />
        <Column
          dataField="EndDate"
          dataType="date"
          format={appConst.dateDisplayFormat}
        />
      </DataGrid>
    </Fragment>
  );
};
